/**
 * Submit the form of a container, optionally with extra data to be added to the post.
 *
 * @param {HTMLElement} $container The container to find the form to submit.
 * @param {object} extraData The extra data to include in the form's payload.
 */
function submitContainerForm($container, extraData = {}) {

    const $form = $container.querySelector('form');

    if (!$form) {
        console.warn('Container had no form, how did the event get fired?');
        return;
    }

    // Already searching? bail...
    if ($container.classList.contains('searching')) {
        return;
    }

    // Get the form's data.
    const formData = new FormData($form);
    const data = Object.fromEntries(formData);
    data.action = 'agend_flexi_search';

    Object.entries(extraData).forEach(entry => {
        data[entry[0]] = entry[1];
    });

    $container.classList.add('searching');

    jQuery.ajax({
        method: 'POST',
        url: agendFlexiSearch.url,
        data
    })
        .done(result => {
            // Replace the container HTML (the result is the shortcode output).
            $container.innerHTML = jQuery(result).html();
        })
        .fail(error => {
            console.log('Error performing search: ', error);
            alert('Sorry, there was an error performing the search. Please try again later.');
        })
        .always(() => {
            $container.classList.remove('searching');

            // Not sure why I'm checking, support is really good now...
            if (typeof $container.scrollIntoView === 'function') {
                $container.scrollIntoView({behavior: "smooth", block: "start"});
            }
        });
}
window.submitContainerForm = submitContainerForm;


function setupFormContainer($container) {
    // Watch for submit events - catch those and push through AJAX.
    $container.addEventListener('submit', event => {
        event.stopImmediatePropagation();
        event.preventDefault();

        const extraData = {};

        // Include the pager button value, if the source of the event was from a button.
        if (
            event?.submitter?.tagName === 'BUTTON'
            && event?.submitter?.type === 'submit'
            && event?.submitter?.name
            && event?.submitter?.value
        ) {
            extraData[event?.submitter?.name] = event?.submitter?.value;
        }

        submitContainerForm($container, extraData);
    });

    // Watch for sort order change events. When that happens, trigger a search.
    $container.addEventListener('change', event => {
        if (
            // Not a select element...
            event?.target?.tagName !== 'SELECT'
            // Not the actual sort mode field...
            || !event?.target?.getAttribute('name')?.match(/_sort_mode$/)
        ) {
            return;
        }

        // Submit the form.
        submitContainerForm($container);
    });

    // Watch for filter change events. When that happens, focus the search button.
    $container.addEventListener('change', event => {
        if (
            // Not a select element...
            event?.target?.tagName !== 'SELECT'
            // Not the actual sort mode field...
            || !event?.target?.classList.contains( 'agend-flexi-search-form__filter-options' )
        ) {
            return;
        }

        // Submit the form.
        submitContainerForm($container);
    });
}

document.addEventListener('DOMContentLoaded', event => {
    const $form_containers = document.querySelectorAll('.agend-flexi-search-form');

    // No forms...
    if ($form_containers.length === 0) {
        return;
    }

    // No jQuery...
    if (typeof jQuery === 'undefined') {
        return;
    }

    // Missing our AJAX URL data...
    if (!agendFlexiSearch?.url) {
        return;
    }

    $form_containers.forEach($form_container => setupFormContainer($form_container));
});
